import React from "react";

const ADO_Sort = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Sort</h1>
      <p>This is the ADO Sort page content.</p>
    </div>
  );
};

export default ADO_Sort;
